import React, { useState, useEffect } from 'react';
import { map } from 'lodash';
import { verifiableCompanyName } from 'libs/api/user';
import { useDataApi } from 'libs/hooks';
import { TModalProps } from 'modules/types';
import { CCountryType } from 'constants/user.const';
import { ECountryType } from 'enums/base.enum';
import { Checkbox, Form, Typography, Col, Row, Modal, Button } from 'antd';
import { RedoOutlined } from '@ant-design/icons';
import { FormWrapper } from 'GlobalStyles';

const { Title } = Typography;
const InternFilterModal = ({ modalState, setModalState }: TModalProps) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [{ data, loading }] = useDataApi<{ value: string }>(verifiableCompanyName.bind(null));

  function handleCancel() {
    setModalState({ visible: false, record: '' });
  }

  function onClickSubmit() {
    setModalState({ visible: false, record: '' });
    const value = {
      countryType: '',
      gpa: '0',
      intern: false,
      tagNames: [] as any[],
      count: 0,
    };
    const countryType = form.getFieldValue('country_type');
    if (countryType) {
      value.countryType = countryType.join('+');
      map(countryType, (v: string) => {
        value.tagNames.push(v);
      });
      value.count = 1;
    }
    const gpa = form.getFieldValue('gpa');
    if (gpa) {
      value.gpa = gpa.join('+');
      map(gpa, (v: string) => {
        value.tagNames.push(v);
      });
      value.count = 1;
    }
    const intern = form.getFieldValue('intern');
    if (intern) {
      value.intern = intern.join('+');
      map(intern, (v: string) => {
        value.tagNames.push(v);
      });
      value.count = 1;
    }

    modalState.onFinish && modalState.onFinish(value);
  }

  useEffect(() => {
    setVisible(modalState.visible);
  }, [modalState.visible]);

  return (
    <Modal
      visible={visible}
      centered={true}
      maskClosable={true}
      closable={true}
      footer={
        <Row gutter={[8, 8]} justify='space-between'>
          <Col>
            <Button
              onClick={() => {
                form.resetFields();
              }}
            >
              <RedoOutlined />
              초기화
            </Button>
          </Col>
          <Col>
            <Button onClick={handleCancel}>닫기</Button>
            <Button type='primary' onClick={onClickSubmit}>
              적용
            </Button>
          </Col>
        </Row>
      }
      width={500}
      onCancel={handleCancel}
    >
      <Title level={3}>필터</Title>
      <FormWrapper style={{ padding: '0px' }}>
        <Form form={form} colon={false} layout='vertical' className='form-normal'>
          <Form.Item name={'country_type'} label='학교'>
            <Checkbox.Group className='checkbox-btn'>
              <Checkbox value={ECountryType.KR}>{CCountryType[ECountryType.KR]}</Checkbox>
              <Checkbox value={ECountryType.US}>{CCountryType[ECountryType.US]}</Checkbox>
              <Checkbox value={ECountryType.UK}>{CCountryType[ECountryType.UK]}</Checkbox>
              <Checkbox value={ECountryType.CN}>{CCountryType[ECountryType.CN]}</Checkbox>
              <Checkbox value={ECountryType.JP}>{CCountryType[ECountryType.JP]}</Checkbox>
              <Checkbox value={ECountryType.ETC}>{CCountryType[ECountryType.ETC]}</Checkbox>
            </Checkbox.Group>
          </Form.Item>
          <Form.Item name={'gpa'} label='학점'>
            <Checkbox.Group className='checkbox-btn'>
              <Checkbox value='3.5'>3.5 이상</Checkbox>
              <Checkbox value='3.0'>3.0 이상</Checkbox>
            </Checkbox.Group>
          </Form.Item>
          {/*
          <Form.Item
            name={'intern'}
            label="인턴 경력"
          >
            <Checkbox.Group className="checkbox-btn">
              <Checkbox value={true}>있음</Checkbox>
            </Checkbox.Group>
          </Form.Item>
          */}
        </Form>
      </FormWrapper>
    </Modal>
  );
};

InternFilterModal.defaultProps = {};

export default InternFilterModal;
